import React from 'react';
import { ExternalLink, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTheme } from '../context/ThemeContext';
import { cn } from '../lib/utils';

export default function Map() {
  const GEOTAB_URL = 'https://my.geotab.com/amazon_fr_arval_byrz_dac2/#dashboard';
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const handleOpenGeotab = () => {
    // Ouvre dans un nouvel onglet (desktop) ou navigateur externe (mobile)
    window.open(GEOTAB_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="space-y-6 p-4" data-testid="map-page">
      <div className={cn(
        "rounded-xl border shadow-sm p-8",
        isDark ? "bg-zinc-900 border-white/10" : "bg-white border-slate-200"
      )}>
        <div className="text-center">
          <div className={cn(
            "inline-flex items-center justify-center w-20 h-20 rounded-full mb-6",
            isDark ? "bg-blue-500/20" : "bg-blue-100"
          )}>
            <MapPin size={40} className="text-blue-500" />
          </div>
          
          <h2 className={cn(
            "text-2xl font-bold mb-3",
            isDark ? "text-white" : "text-gray-900"
          )}>
            Géolocalisation des véhicules
          </h2>
          
          <p className={cn(
            "text-base mb-8 max-w-md mx-auto",
            isDark ? "text-zinc-400" : "text-slate-600"
          )}>
            Accédez à la plateforme Geotab pour suivre vos véhicules en temps réel
          </p>
          
          {/* Bouton principal au centre */}
          <Button
            onClick={handleOpenGeotab}
            size="lg"
            className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all"
            data-testid="geotab-redirect-button"
          >
            <ExternalLink size={24} />
            Ouvrir Geotab
          </Button>
          
          <p className={cn(
            "text-sm mt-4",
            isDark ? "text-zinc-500" : "text-slate-500"
          )}>
            S'ouvre dans un nouvel onglet
          </p>
        </div>
      </div>

      <div className={cn(
        "border-l-4 border-blue-500 p-4 rounded-r-lg",
        isDark ? "bg-blue-500/10" : "bg-blue-50"
      )}>
        <div className="flex">
          <div className="flex-shrink-0">
            <ExternalLink className={cn(
              "h-5 w-5",
              isDark ? "text-blue-400" : "text-blue-400"
            )} />
          </div>
          <div className="ml-3">
            <h3 className={cn(
              "text-sm font-medium",
              isDark ? "text-blue-300" : "text-blue-800"
            )}>
              Plateforme externe Geotab
            </h3>
            <div className={cn(
              "mt-2 text-sm",
              isDark ? "text-blue-200/70" : "text-blue-700"
            )}>
              <p>
                La géolocalisation des véhicules est gérée par la plateforme Geotab.
                <br />
                Vous pouvez y consulter :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Position en temps réel de tous les véhicules</li>
                <li>Historique des trajets</li>
                <li>Rapports d'utilisation</li>
                <li>Alertes et notifications</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
